<template>
  <div>
    <div id="container">
      <div class="button-wrapper">
        <div class="button-group">
          <div class="vue-uploader">
            <el-button
              type="primary"
              size="medium"
              @click="
                mxGoUrl(
                  mxGetOssUrl(
                    '/sample/excel/%E6%89%B9%E6%AC%A1%E4%BB%BB%E5%8A%A1%E7%BB%93%E7%AE%97%E6%A8%A1%E6%9D%BF.xlsx',
                    true
                  )
                )
              "
            >
              下载结算单excel表
            </el-button>
            <el-button
              type="primary"
              :id="selectfiles"
              size="medium"
              class="submitBtn"
              :disabled="this.selecBtnStatus"
            >
              导入结算单
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable   */
import plupload from "plupload";
import XLSX from "xlsx";

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    multiSelection: {
      type: Boolean,
      default: false,
    },
    dir: {
      type: String,
      default: "",
    },
    postfiles: {
      type: String,
      default: null,
    },
    company_id: {
      type: String,
      default: null,
    },
    max_width: {
      type: Number,
      default: 0,
    },
    max_height: {
      type: Number,
      default: 0,
    },
    beforeUpload: {
      type: Function,
    },
  },
  data() {
    return {
      selecBtnStatus: false,
      selectfiles: "homeTaxSelectFiles",
      tableKeyMap: {
        code: "code",
        name: "bank_account_name",
        bankCard: "bank_account_no",
        accountName: "bank_branch",
        moneyType: "money_type_name",
        money: "money",
        phone: "mobile",
        idCard: "id_number",
        cardType: "id_type",
        remark: "remark",
        type: "send_type",
        bankName: "bank_name",
        green_trade_no: "green_trade_no",
      },
      loadingStaus: false,
      sign: [],
      file: [],
      prograss: [],
      url: [],
      filename: "", // 文件原始名
      arrUrl: [],
      tableDataArr: [],
      excelData: {
        header: null,
        results: null,
      },
    };
  },
  computed: {},
  mounted() {
    this.upload();
  },
  methods: {
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let tempArr = [];
        this.tableColumns.map((item) => {
          tempArr.push(v[item.value]);
        });
        return tempArr;
      });
    },
    handle_del_files() {
      this.file = [];
    },
    // plupload 相关配置
    upload() {
      const uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4", // 制定上传方式
        browse_button: this.selectfiles, // dom元素的id
        multi_selection: this.multiSelection,
        container: document.getElementById("container"),
        url: "http://oss.aliyuncs.com",
        // 当Plupload初始化完成后触发监听函数参数
        init: {
          PostInit: () => {},
          // 当文件添加到上传队列后触发监听函数参数

          FilesAdded: (up, files) => {
            var fileLen = uploader.files.length;
            if (fileLen > 1) {
              uploader.splice(0, fileLen - 1); //清空上传队列
            }

            //  判断是否重复
            if (!this.file.includes(files[0].name)) {
              if (
                files[0].name.substring(files[0].name.lastIndexOf(".") + 1) !==
                  "xlsx" &&
                files[0].name.substring(files[0].name.lastIndexOf(".") + 1) !==
                  "xls"
              ) {
                this.$message.error(
                  "文件格式只能是.xlsx 或 .xls,请上传正确格式的文件"
                );
                return false;
              }
              this.file.push(files[0].name);
              this.prograss.push({
                name: files[0].name,
                prograss: 0,
              });
            }
            if (this.multiple === false) {
              this.file = this.file.slice(0, 1);
              // 读取Excel文件
              const reader = new FileReader();
              reader.onload = (e) => {
                let preview = this.result;
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: "array" });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const header = this.getHeaderRow(worksheet);
                const results = XLSX.utils.sheet_to_json(worksheet);
                let tableDataArr = [];
                for (var item in results) {
                  if (results.hasOwnProperty(item)) {
                    if (!results[item].idCard) {
                      delete results[item];
                      continue;
                    }
                  }
                }
                results.map((item) => {
                  let tmp = {};
                  for (let key of Object.keys(item)) {
                    tmp[this.tableKeyMap[key]] = item[key];
                  }
                  tableDataArr.push(tmp);
                });
                tableDataArr.splice(0, 1);

                this.$emit("return_url", {
                  tableData: tableDataArr,
                });
                this.tableHeader = header;

                if (tableDataArr.length) {
                  if (this.url.key) {
                    this.$emit("return_url", {
                      tableData: tableDataArr,
                    });
                  }
                } else {
                  this.$alert("请重新选择Excel文件。", "提示", {
                    confirmButtonText: "确定",
                    callback: (action) => {},
                  });
                }
                uploader.refresh();
              };
              reader.readAsArrayBuffer(files[0].getNative());
              return;
            }
          },
          // 上传前
          BeforeUpload: (up, file) => {
            this.set_upload_param(up, file.name, true);
          },
          // 上传完成
          FileUploaded: (up, file, info) => {
            if (this.url.length) {
              this.url.forEach((val, index) => {
                const fileItem = file[index];
                this.$emit("return_url", {
                  url: this.imgurl,
                  filename: this.filename,
                  size: fileItem.size,
                });
              });
            } else {
              this.$emit("return_url", {
                url: this.imgurl + this.url.key,
                filename: this.filename,
                size: file.size,
              });
            }

            uploader.splice();
            uploader.refresh();
          },
          Error: (up, args) => {
            this.$message.error("上传失败");
            this.$emit("return_url", "error");
          },
        },
      });
      uploader.init();

      // document.getElementById(this.postfiles).onclick = () => {
      //   console.log("触发事件");
      //   if (this.excelData.results) {
      //     if (this.url.key) {
      //       this.$emit("return_url", {
      //         url: this.imgurl + this.url.key,
      //         filename: this.filename,
      //       });
      //     }
      //   } else {
      //     this.$alert("请先选择Excel文件。", "提示", {
      //       confirmButtonText: "确定",
      //       callback: (action) => {},
      //     });
      //   }
      //   this.set_upload_param(uploader, "", false);
      //   return false;
      // };
    },
    set_upload_param(up, filename, ret) {
      this.filename = filename;
      const time = new Date().getTime() + Math.random() * 1000;
      let key;
      if (this.company_id) {
        key =
          this.sign.dir +
          this.company_id +
          "/" +
          time +
          "." +
          filename.split(".")[filename.split(".").length - 1];
      } else {
        key =
          this.sign.dir +
          time +
          "." +
          filename.split(".")[filename.split(".").length - 1];
      }

      const sign = this.sign;
      const new_multipart_params = {
        key,
        policy: sign.policy,
        OSSAccessKeyId: sign.accessid,
        success_action_status: "200", // 让服务端返回200,不然，默认会返回204
        signature: sign.signature,
      };
      // 设定缩放尺寸大小
      const resize = {
        width: this.max_width,
        height: this.max_height,
      };
      !resize.width && delete resize.width;
      !resize.height && delete resize.height;
      const options = {
        url: sign.host,
        resize,
        multipart_params: new_multipart_params,
      };

      if (JSON.stringify(resize) == "{}") {
        delete options.resize;
      }
      up.setOption(options);
      up.start();
      this.arrUrl = [];
      if (this.multiple === true) {
        // 图片和视频
        // if (key.includes('.jpeg') || key.includes('.jpg') || key.includes('.png') || key.includes('.gif') || key.includes('.xls') || key.includes('.xlsx') || key.includes('.csv') || key.includes('.mp4')) {
        // }
      } else {
        // 图片和视频
        if (
          key.includes(".jpeg") ||
          key.includes(".jpg") ||
          key.includes(".png") ||
          key.includes(".gif") ||
          key.includes(".xls") ||
          key.includes(".xlsx") ||
          key.includes(".csv") ||
          key.includes(".mp4")
        ) {
          this.arrUrl.push({ key });
          this.url = this.arrUrl[0];
        }
      }
    },
    //  移出文件
    remove(index) {
      this.file.splice(index, 1);
      this.$emit("remove_file");
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        /* find the cell in the first row */
        let hdr = "UNKNOWN " + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  color: #fff;
  cursor: pointer;
  text-decoration: none;
}
.submitBtn {
  margin-right: 10px;
}
.button-group {
  display: flex;
  justify-content: space-between;
  .vue-uploader {
    height: 40px;
    display: flex;
    border-radius: 4px;
    .file-item {
      position: relative;
    }
    .file-remove {
      position: absolute;
      right: 4px;
      display: none;
      top: 4px;
      width: 20px;
      height: 40px;
      font-size: 20px;
      text-align: center;
      color: white;
      cursor: pointer;
      line-height: 18px;
      border-radius: 100%;
      transform: rotate(45deg);
      background: rgba(0, 0, 0, 0.5);
    }
    .file-item:hover .file-remove {
      display: block;
    }
    .prograss {
      transition: all 0.5s;
      border-radius: 4px;
      background-color: rgb(92, 184, 92);
      background-image: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.14902) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.14902) 50%,
        rgba(255, 255, 255, 0.14902) 75%,
        transparent 75%,
        transparent
      );
      background-size: 40px 40px;
      box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;
      box-sizing: border-box;
      height: 4px;
      margin: {
        bottom: 5px;
      }
    }
  }
}

.netbar_logo {
  width: 100%;
  height: 100px;
  // background: red;
  margin: {
    bottom: 15px;
  }
  div {
    width: 100px;
    height: 100px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
</style>
